import React, { useState } from 'react';
import { InfoCard } from '@backstage/core-components';
import { catalogApiRef, useEntity } from '@backstage/plugin-catalog-react';
import { useApi } from '@backstage/core-plugin-api';
import { useAsync } from 'react-use';
import { stringifyEntityRef, UserEntity } from '@backstage/catalog-model';
import { Grid } from '@material-ui/core';
import { MemberComponent } from '../MembersListCard';

/**
 * Lists the users of a contact list of the entity. Defaults to the technical
 * contacts, departments reuse it for their security contacts.
 */
export const TechnicalContactsCard = (props?: {
  field?: string;
  title?: string;
}) => {
  const field = props?.field ?? 'technicalContacts';
  const { entity } = useEntity();
  const catalogApi = useApi(catalogApiRef);
  const [memberEntities, setMemberEntities] = useState<UserEntity[]>();
  // Left undefined rather than defaulted to an empty array: it is a dependency
  // of the effect below, and a fresh `[]` on every render would re-run it on
  // every render. The absent case is handled where it is read.
  const technicalContacts = entity?.spec?.[field] as any[] | undefined;

  useAsync(async () => {
    // Not every entity carries the list, and the card is rendered for some
    // that do not - an empty one beats a TypeError that nothing reads.
    const entityRefs = (technicalContacts ?? []).map(it =>
      stringifyEntityRef({ kind: 'User', name: it.entityRef }),
    );
    const membersList = await catalogApi.getEntitiesByRefs({
      entityRefs: entityRefs,
    });
    const memberListItems = membersList.items?.filter(it => !!it);
    setMemberEntities(memberListItems as UserEntity[]);
  }, [technicalContacts, entity, catalogApi]);

  return (
    <InfoCard title={props?.title ?? 'Technical Contacts'} variant="gridItem">
      <Grid container spacing={1}>
        {(memberEntities || []).map(entity => (
          <MemberComponent
            member={entity}
            key={entity?.metadata?.uid}
            sm={12}
            md={6}
            xl={4}
          />
        ))}
      </Grid>
    </InfoCard>
  );
};
